<style lang="scss">
.d2-avatar-uploader {
  &.is-empty {
    .el-upload {
      border-style: dashed;
    }
  }
  .el-upload {
    border-color: #DCDFE6;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #C0C4CC;
    }
  }
  .icon {
    font-size: 28px;
    color: #8c939d;
    text-align: center;
  }
  .avatar {
    display: block;
  }
}
</style>

<template>
  <div class="d2-avatar-uploader">
    <el-upload
      action="fakeaction"
      :class="{ 'is-empty': isEmpty }"
      :style="styleUploader"
      :show-file-list="false"
      :http-request="httpRequest"
      :on-success="onSuccess">
      <img
        v-if="currentValue"
        :src="currentValue"
        class="avatar"
        :style="styleAvatar">
      <i
        v-else
        class="el-icon-plus icon"
        :style="styleIcon"/>
    </el-upload>
  </div>
</template>

<script>
import commonModels from '@/common/models/common-models'
import { mapState } from 'vuex'
import md5 from 'js-md5'
import { vModelString } from '@/mixins/component-vmodel.js'
export default {
  name: 'd2-avatar-uploader',
  mixins: [
    vModelString
  ],
  props: {
    width: { type: Number, default: 100, required: false },
    height: { type: Number, default: 100, required: false },
    limit: { type: Number, default: 1, required: false }
  },
  data () {
    return {
      status: {
        loading: false
      }
    }
  },
  computed: {
    isEmpty () {
      return !this.currentValue
    },
    styleUploader () {
      return {
        height: this.height + 'px',
        width: this.width + 'px'
      }
    },
    styleAvatar () {
      return {
        height: this.height - 2 + 'px',
        width: this.width - 2 + 'px'
      }
    },
    styleIcon () {
      return {
        height: this.height - 2 + 'px',
        width: this.width - 2 + 'px',
        lineHeight: this.height - 2 + 'px'
      }
    },
    info(){
      return this.$store.getters.getUser.info
    },
    ...mapState( [
      'bucketParameter',
      'resourcePrefix'
    ])
  },
  methods: {
    checkLimit (file) {
      let result = true
      if (file.size > this.limit * 1024 * 1024) {
        this.$message.error(`头像图片大小不能超过${this.limit}MB`)
        result = false
      }
      return result
    },
    onSuccess(res) {
      this.currentValue = res.url
      this.$emit('on-success', this.currentValue)
    },
    httpRequest(params) {
      console.log(this.info)
      console.log(this.bucketParameter)
      console.log(this.resourcePrefix)
      // 记录file以及fileType
      const file = params.file,
            fileType = params.file.type;
      // 获取文件后缀
      const file_extension = file.name.substr(file.name.lastIndexOf('.')+1, file.name.length)
      // 记录当前时间戳（精确到秒的）
      const timestamp = Date.parse(new Date()) / 1000
      // 生成文件名(当前用户的uuid + username + 时间戳 + md5(file.uid) 确保文件名在存储桶中不重复)
      const fileName = this.info.id + "_" + this.info.nickname + "_" + timestamp + "_" + md5(file.uid + '') + file.name.substr(file.name.lastIndexOf('.'), file.name.length)
      // 拼接文件路径
      let path = "/system/user/avatar/" + fileName

      // 假的连接0v0，实际上只是返回一个 connect 对象
      var client = commonModels.ossConnect(this.bucketParameter)
      // 大于 2M 的使用分片上传
      if( file.size/1024/1024 >= 2 ){
        console.log("分片上传")
        // 分片上传(ps:大文件适用)
        client.multipartUpload(path, file, {
          // 进度条
          progress: function(p) {
            let percent = Math.ceil(p * 100)
            if (percent > 100) {
              percent = 100;
            }
            // element upload onProgress 上传进度钩子，以便获取实时进度
            params.onProgress(percent)
          }
        })
        .then(response => {
          // response 中有 res 参数
          const { res } = response
          if (res.status === 200) {
            // 自定义返回参数
            let data = {
              uid: file.uid, // 文件的 uid
              name: fileName, // 通过规则生成的文件名
              old_name: file.name, // 上传时的文件名
              type: fileType, // 文件上传组件判断的文件类型
              file_extension: file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
              size: file.size, // 文件大小
              url: this.resourcePrefix.url + '/' + response.name, // url
              duration: this.videoDuration ? Math.round(duration) : "videoDuration is false.", // 视频时长
              code: 200 // 状态码
            }
            // element upload onSuccess 上传成功钩子
            params.onSuccess(data)
          }
        })
        .catch(error => {
          // element upload onError 上传失败钩子
          params.onError(error)
        })
      } else {
        console.log("文件流上传")
        client.put(path, file)
        .then(response => {
          // response 中有 res 参数
          const { res } = response
          if (res.status === 200) {
            // 自定义返回参数
            let data = {
              uid: file.uid, // 文件的 uid
              name: fileName, // 通过规则生成的文件名
              old_name: file.name, // 上传时的文件名
              type: fileType, // 文件上传组件判断的文件类型
              file_extension: file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
              size: file.size, // 文件大小
              url: this.resourcePrefix.url + '/' + response.name, // url
              duration: this.videoDuration ? Math.round(duration) : "videoDuration is false.", // 视频时长
              code: 200 // 状态码
            }
            // element upload onSuccess 上传成功钩子
            params.onSuccess(data)
          }
        })
        .catch(error => {
          // element upload onError 上传失败钩子
          params.onError(error)
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/d2-avatar-uploader/component.vue